import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';
import {
  profileQueryKeys,
  useProfileMutationFeedback,
} from './useProfileMutationFeedback';

const upsertDiveInsuranceMutation = graphql(/* GraphQL */ `
  mutation upsertDiveInsurance($input: DiveInsuranceInput!) {
    upsertDiveInsurance(input: $input)
  }
`);

export type DiveInsuranceInput = {
  insuranceId: number;
  userId: string;
  policyNumber: string;
};

const useUpsertDiveInsurance = () => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const userId = user?.sub ?? '';
  const feedback = useProfileMutationFeedback({
    successMessage: 'Dive insurance saved',
    queryKeys: [profileQueryKeys.diveInsurance(userId)],
  });

  return useMutation({
    mutationFn: async (input: DiveInsuranceInput) => {
      if (!isAuthenticated) {
        throw new Error('User must be authenticated to upsert dive insurance');
      }
      return graphqlRequest(
        upsertDiveInsuranceMutation,
        { input },
        getAccessTokenSilently,
      );
    },
    ...feedback,
  });
};

export default useUpsertDiveInsurance;
